<template>
  <el-table-column
    :width="field.width"
    :sortable="field.sortable ? 'custom' : false"
    :label="field.label"
    :prop="field.prop"
    :key="field.prop"
  >
    <template slot-scope="scope" class="pull-right">
      <component-compiler
        v-for="(component, i) in fields(scope.row)"
        :content="component"
        :key="`order-column-${i}`"
      />
    </template>
  </el-table-column>
</template>

<script>
import { get } from 'lodash'
import ComponentCompiler from '@/components/ComponentCompiler'

export default {
  props: ['field'],
  components: {
    ComponentCompiler
  },
  computed: {
    articles() {
      return scope => get(scope.row, this.field.prop)
    },
    lookupKwarg() {
      let lookup = this.field.lookupKwarg
      if (!lookup) {
        lookup = 'id'
      }
      return lookup
    }
  },
  data() {
    return {
      buttonsDisabled: false
    }
  },
  methods: {
    getDetailsRouteParams(instance) {
      const params = {}
      params[this.lookupKwarg] = instance[this.lookupKwarg]
      return params
    },
    fields(row) {
      return [
        this.getButtonComponent({
          icon: 'fa fa-arrow-down',
          onClick: () => this.moveDown(row),
          type: 'basic',
          style: 'margin-left: 0',
          disabled: this.buttonsDisabled
        }),
        this.getButtonComponent({
          icon: 'fa fa-arrow-up',
          onClick: () => this.moveUp(row),
          type: 'basic',
          style: 'margin-left: 0',
          disabled: this.buttonsDisabled
        })
      ]
    },
    moveElement(row, serviceMethod) {
      const lookupParams = { id: row.id }
      this.buttonsDisabled = true
      this.field.setListAsLoading()
      serviceMethod(lookupParams)
        .then(response => {
          this.$message({
            message: 'Zmieniono kolejność artykułu',
            type: 'success'
          })
          this.field.fetchDataCallback()
        })
        .catch(error => {
          this.$message({
            message: 'Wystąpił błąd podczas zmieniania kolejności artykułu',
            type: 'error'
          })
        })
        .finally(() => {
          this.buttonsDisabled = false
        })
    },
    moveUp(row) {
      this.moveElement(row, this.field.service.moveUp)
    },
    moveDown(row) {
      this.moveElement(row, this.field.service.moveDown)
    }
  }
}
</script>

<style lang="scss" scoped>
.thumbnail {
  max-width: 120px;
}
</style>
